/* =============================================================================
=    Send email verification code
============================================================================= */
import { gql } from '@apollo/client';

export default gql`
mutation sendEmailCode($email: String!) {
  sendEmailCode(email: $email) {
    code
    message
  }
}
`;
